
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points forts?`}</em></p>
    <p>{`Il est bon marché et facile à conserver (il doit être gardé dans un
réfrigérateur, entre deux et huit degrés). Il peut donc être très utile pour une
vaccination de masse, en particulier dans les pays en voie de développement.`}</p>
    <p>{`Des doses ont commencé à être délivrées dans le cadre de l'initiative Covax en
mars 2021. Le 29 juillet 2021, Oxford a annoncé
qu'`}<a parentName="p" {...{
        "href": "https://www.ox.ac.uk/news/2021-07-29-oxford-vaccine-reaches-one-billion-doses-released"
      }}>{`un million de doses`}</a>{`
avaient déjà été distribuées dans le monde entier. Le "New York Times" relève
toutefois que des goulets d'étranglement au niveau de la fabrication ont ralenti
le processus. Selon le quotidien, l'entreprise prévoit une capacité annuelle de
deux milliards de doses.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;